module.exports = __webpack_public_path__ + "img/bcc054.2a794e25.jpeg";